var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Tshirts",

    getDefaultProps () {
        return {"width":"22px","height":"22px","viewBox":"0 0 22 22","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>Icon/T-Shirts</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Icon/T-Shirts" fill="#000000">
      <g id="T-Shirts">
        <polygon id="Combined-Shape" points="10 16 10 20 18 20 18 13.9192352 20.4077356 14.9912282 22 11.3370463 16.6249468 8.92847698 15.4213532 11.6317924 14 10.9989652 14 16"/>
        <path d="M6.08774091,2.62660947 L3.38662431e-12,5.33704635 L1.62694657,8.99122818 L4,7.93467672 L4,14 L12,14 L12,7.91923524 L14.4077356,8.99122818 L16.0346821,5.33704635 L9.91638229,2.61300375 C9.66965973,3.4377736 8.90503133,4.03890998 8,4.03890998 C7.09995272,4.03890998 6.33876621,3.44437633 6.08774091,2.62660947 Z" id="Combined-Shape-Copy"/>
      </g>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/ui/images/T-Shirts.svg